import React from "react";
import "./index.scss";
import { Col, Row } from "react-bootstrap";
import bg1 from "../../../assets/images/sim1.png";
import bg2 from "../../../assets/images/sim2.png";
import { useNavigate } from "react-router-dom";
export const SimulationSection = () => {
  const navigate = useNavigate();
  return (
    <div className="SimulationSection-container">
      {" "}
      <div className=" d-flex align-items-center justify-content-between flex-column flex-md-row ">
        <div className="simulation-title">
          Votre meilleure <br className="br-mobile" />
          simulation
        </div>
        <div className="simulation-description">
          Découvrez le potentiel réel de votre projet grâce à notre
          <br className="br-mobile" /> outil de simulation innovant.
        </div>
      </div>
      <Row className="align-items-center justify-content-center mt-5 mb-5 g-3">
        <Col md={8}>
          {" "}
          <div
            className="simulation-img"
            style={{ backgroundImage: `url(${bg1})` }}
          >
            <button
              className="btn-simulation"
              onClick={() => {
                navigate("/simulation#form-section");
              }}
            >
              Simulation Gratuite
            </button>
          </div>{" "}
        </Col>

        <Col md={4} className="d-none d-md-block">
          <div
            className="simulation-img"
            style={{ backgroundImage: `url(${bg2})` }}
          ></div>
        </Col>
      </Row>
    </div>
  );
};
